// Firebase Config
const firebaseConfig = {
  apiKey: "AIzaSyBuSd6-ErZ6udgcyD6O-VJP998tBYvx5H0",
  authDomain: "helloween-2020.firebaseapp.com",
  databaseURL: "https://helloween-2020.firebaseio.com",
  projectId: "helloween-2020",
  storageBucket: "helloween-2020.appspot.com",
  messagingSenderId: "747760608922"
}

// Exports
module.exports = firebaseConfig;